var map = {
	"./1.png": 7813,
	"./2.png": 9286,
	"./3.png": 7454,
	"./4.png": 4560,
	"./AIGC.png": 8992,
	"./Group106.png": 7322,
	"./Group107.png": 8413,
	"./Group108.png": 3737,
	"./Group109.png": 3624,
	"./Group110.png": 8872,
	"./Group1101.png": 3032,
	"./Group1102.png": 1786,
	"./Group1103.png": 5878,
	"./Group1104.png": 7106,
	"./Group1105.png": 1523,
	"./Group1106.png": 7865,
	"./Group111.png": 9148,
	"./Group119.png": 9617,
	"./Group120.png": 3773,
	"./Group121.png": 4476,
	"./Group126.png": 4786,
	"./arrow.png": 8054,
	"./云产品.png": 8415,
	"./云游戏1.png": 713,
	"./云电脑.png": 7749,
	"./前景覆层.png": 1395,
	"./背景装饰.png": 8261,
	"./背景装饰2.png": 6059,
	"./装饰1.png": 2266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4279;